<template>
    <v-card v-show="authenticatedUser && productId !== -1 && hasOrdered" class="bought-notifications">
      <v-icon color="accent" class="bought-icon">
            mdi-checkbox-marked-circle
      </v-icon>Previously purchased on {{ getOrderDate() | formatDateLong }}
    </v-card>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "DateBoughtNotification",
  props: {
    productId: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      authenticatedUser: state => state.auth.authenticatedUser
    }),
    hasOrdered () {
      return (this.getOrderDate().length > 0)
    }
  },
  methods: {
    getOrderDate () {
      let orderDate = ''
      if (this.authenticatedUser && this.authenticatedUser.orders && this.productId !== -1) {
        for (let i = 0; i < this.authenticatedUser.orders.length; i++) {
          const pId = this.authenticatedUser.orders[i].productIds.find(
            x => x === this.productId
          )
          if (pId) {
            orderDate = this.authenticatedUser.orders[i].createdAt
          }
        }
      }
      return orderDate
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/variables';

.bought-notifications {
  border: 1px solid $soft-green;
  font-size: 1.6em;
  margin: 20px 0px 20px 20px;
  padding: 20px;

  .bought-icon {
    margin-right:10px;
  }
}
</style>
